module.exports = __webpack_public_path__ + "static/media/bible.237fbe0d.png";